<template>
  <div class="ecran-acc bg-red">
    <div class="title">Bonjour !</div>

    <div class="texte">
      Besoin d'un conseil de lecture ? <br />
      Je suis là pour vous aider !
    </div>
    <img src="../img/coccinelle.png" alt="Image Coccinelle Dargaud" />

    <button class="submit btn-white" @click="accueilNext()">
      C'est parti !
    </button>
  </div>
</template>

<style lang="scss" scoped>
$red: #f52246;

.bg-red {
  background-color: $red;
  color: white;
}

.ecran-acc {
  height: 100%;
  padding: 20px 16px;

  .title {
    margin: 70px 0 10px 0;
    font-size: 26px;
    letter-spacing: -0.2px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .texte {
    font-size: 20px;
    line-height: 1.4;
    letter-spacing: -0.78px;
  }

  img {
    display: block;
    //margin: 40px auto 70px auto;
    margin: 15% auto 70px auto;
    height: 34%;
    max-width: 150px;
  }

  .btn-white {
    width: 300px;
    height: 60px;
    line-height: 58px;
    border: 1px solid white;
    font-size: 16px;
    background-color: white;
    color: #f52246;
    border-radius: 4px;
    letter-spacing: -0.18px;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>

<script>
import { mapMutations } from "vuex";

export default {
  // les différentes methodes du store
  methods: {
    ...mapMutations([
      "SET_CURRENTPAGE",
      "SET_CURRENTQUESTION",
      "SET_ADDHISTORY",
      "SET_CPTNEWRES"
    ]),
    accueilNext: function() {
      this.SET_CURRENTPAGE(1);
      this.SET_CURRENTQUESTION(1);
      this.SET_ADDHISTORY(1);
      this.SET_CPTNEWRES(0);
    }
  }
};
</script>
